var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-layout',[_c('div',{staticClass:"player-page"},[_c('div',{staticClass:"player-wrapper"},[(_vm.started)?_c('div',{staticClass:"player-container"},[_c('video-player',{ref:"videoPlayer",attrs:{"video-source":_vm.channelUrl,"unmuted":_vm.unmuted,"is-live-delivery-player":true},on:{"muteChanged":_vm.setUnmuted}})],1):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3de5dab0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Channel/index.vue
// module id = b64E
// module chunks = 1